import React, { Component } from 'react';

import './LoginBox.css';
import loadingImg from '../img/ball.png';

export default class LoginBox extends Component {

    constructor() {
        super();
        this.state = {
          playerName: "",
          playerHandle: "",
          playerLink: "",
          playerImage: false, // false: not searched, "searching": searching, "not found": not found, everything else: image url 
          helpOpen: false
        }

        this.searchTimerHandle = false;
    }

    _handleChange = (event) => {
        if(event.target.name === "name"){
            // handle the name input
            const name = event.target.value.substring(0,6)       
            this.setState({playerName: name});
        }else if(event.target.name === "handle"){
            // handle the handle input
            const input = event.target.value;
            this.setState({playerHandle: input});
            this._searchForImage(input);
        }
    }

    _handleImageError = (event) => {
        this.setState({
            playerImage: "not found",
            playerLink: ""
        })
    }

    _searchForImage = (input) => {

        // define the image url based on input.
        // possible options are currently a (homepage) url, a twitter handle (@name) or a github user (everything else)
        // NOTE, for more controll (for example to find better favicon image), the request must be made on the server
        // to avoid CORS problems

        clearTimeout(this.searchTimerHandle); // debounce users input
        
        if(!input){
            // reset the playerImage to false
            return this.setState({
                    playerImage: false,
                    playerLink: ""
                })
        }

        this.setState({
            playerImage: "searching",
            playerLink: ""
        })

        this.searchTimerHandle = setTimeout( (input) => {

            let playerImage = false
            let playerLink = ""
            if(input.includes("http://") || input.includes("https://")){
                // use urls favicon
                playerImage = `https://s2.googleusercontent.com/s2/favicons?domain=${input}`
                playerLink = input
            }else if(input.startsWith("@")){
                // use twitter icon
                input = input.substr(1) // remove the @ sign
                if(input.length >= 1){ // min 1 character
                    playerImage = `https://avatars.io/twitter/${input}/small` // note: this gets the image but also sends a default image if the user is not found and thus will not cause the image error :/
                    playerLink = `https://twitter.com/${input}`
                }
            }else{
                // use github icon
                playerImage = `https://github.com/${input}.png?size=40`
                playerLink = `https://github.com/${input}`
            }

            this.setState({
                playerImage,
                playerLink
            })

        }, 500, input)
    }

    _handleSubmit = (event) => {
        event.preventDefault();
        const player = {
            name: this.state.playerName,
            handle: this.state.playerHandle,
            link: this.state.playerLink,
            image: this.state.playerImage
        }
        this.props.setPlayerAndStart(player)
    }

    _handleHelpClick = (event) => {
        event.preventDefault();
        this.setState({
            helpOpen: !this.state.helpOpen
        })
    }

    shouldComponentUpdate(nextProps, nextState){
        return this.state.playerName !== nextState.playerName ||
            this.state.playerHandle !== nextState.playerHandle ||
            this.state.playerLink !== nextState.playerLink ||
            this.state.playerImage !== nextState.playerImage ||
            this.state.helpOpen !== nextState.helpOpen
    }

    render() {
        return (
            <div className="lobo-wrapper">
                <div className="lobo-box">
                    <div className = "lobo-title">
                        ZEN BALLS
                    </div>
                    <div className="lobo-intro">
                        <p>
                            Zen Balls is a physics simulation (kind of)
                        </p>
                        <p>
                            Use the arrow keys, the mouse or the joystick (anywhere outside the field) to stear your (blue) ball and avoid collisions as long as possible.
                        </p>
                    </div>
                    <form className="lobo-form" onSubmit={this._handleSubmit}>
                        <div className="lobo-client-icon-wrapper">
                            {this.state.playerImage === "searching"
                                ? <img className="lobo-searching-img" alt="Searching Icon" src={loadingImg}/>
                                : this.state.playerImage === "not found" 
                                    ? "no match found :/"
                                    : this.state.playerImage 
                                        ? <img className="lobo-client-img" alt="Player Icon" src={this.state.playerImage} onError={this._handleImageError}/>
                                        : null
                            }
                        </div>
                        <label>
                            <p>Name</p> 
                            <input className="lobo-form-input" type="text" placeholder="Hans!" name="name" value={this.state.playerName} onChange={this._handleChange} />
                        </label>
                        <label>
                            <p className="lobo-link-label" onClick={this._handleHelpClick}>Link</p>
                            <input className="lobo-form-input" type="text" placeholder="url, @twitter, github" name="handle" value={this.state.playerHandle} onChange={this._handleChange} />
                        </label>
                        <input className="lobo-form-button" type="submit" value="Go!" />
                    </form>
                </div>
                {
                    this.state.helpOpen &&
                        <div className="lobo-help-box">
                            <div className="lobo-help-content">
                                <p>
                                    Every hour the player with the most seconds will be added to the Hall Of Fame for the next 24 hours. If you add a link (to your homepage or your twitter handle (with @) or your github user name) it will appear in the HoF (using either the pages favicon or your profile image).
                                </p>
                                <button className="lobo-help-close-button" onClick={this._handleHelpClick}>close</button>
                            </div>
                        </div>
                }
            </div>
        )
    }
}